import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { stepTypes } from '@easybutton/constants'

import { fetchDatabases, getDatabase } from '../../../../ducks/databases'
import { getCurrentOrganizationId } from '../../../../ducks/users'

import Pipe from '../../../Shared/Pipe'
import Card from '../../../Shared/Card'
import Button from '../../../Shared/Button'

import DatabaseStep from './Database'
import APIStep from './API'

import styles from './Steps.module.css'

const MAPPING = {
  [stepTypes.DATABASE]: DatabaseStep,
  [stepTypes.API]: APIStep,
}

export function StepItem({ actionId, step, position }) {
  const { databaseId } = step
  const database = useSelector(getDatabase(databaseId))

  const label =
    step.stepType === stepTypes.DATABASE && database ? database.name : ''

  const ChildComponent = MAPPING[step.stepType]

  if (!ChildComponent) {
    return null
  }

  return (
    <Card className={styles.step}>
      <div className={styles.editButton}>
        <Button
          small
          text
          icon="edit"
          to={`/actions/${actionId}/steps/${step.id}`}
        >
          Edit Step
        </Button>
      </div>
      <h5>
        Step {position}
        {label ? ` – ${label}` : null}
      </h5>
      <ChildComponent step={step} actionId={actionId} />
    </Card>
  )
}

export default function Steps({ action }) {
  const dispatch = useDispatch()
  const organizationId = useSelector(getCurrentOrganizationId)

  useEffect(() => {
    dispatch(fetchDatabases(organizationId))
  }, [dispatch])

  const { steps } = action.details

  return steps.map((step, i) => (
    <React.Fragment key={step.id}>
      <StepItem step={step} position={i + 1} actionId={action.id} />
      <Pipe />
    </React.Fragment>
  ))
}
